import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { messages } from '../components/i18n';
import { customCategory, dataURLPrefix } from './constants';
export var isSpriteServiceRepresentation = function isSpriteServiceRepresentation(rep) {
  return !!(rep && rep.spriteRef);
};
export var isSpriteRepresentation = function isSpriteRepresentation(rep) {
  return !!(rep && rep.sprite);
};
export var isImageRepresentation = function isImageRepresentation(rep) {
  return !!(rep && rep.imagePath);
};
export var isMediaRepresentation = function isMediaRepresentation(rep) {
  return !!(rep && rep.mediaPath);
};
export var isPromise = function isPromise(p) {
  return !!(p && p.then);
};
export var isEmojiDescription = function isEmojiDescription(possibleEmojiDescription) {
  return possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
};
export var isMediaEmoji = function isMediaEmoji(emoji) {
  return isMediaRepresentation(emoji.representation);
};
export var hasDataURLImage = function hasDataURLImage(rep) {
  return isImageRepresentation(rep) && rep.imagePath.indexOf(dataURLPrefix) === 0;
};
export var isLoadedMediaEmoji = function isLoadedMediaEmoji(emoji) {
  return emoji.category === customCategory && hasDataURLImage(emoji.representation);
};
export var isEmojiDescriptionWithVariations = function isEmojiDescriptionWithVariations(emoji) {
  return !!(emoji && emoji.skinVariations);
};
export var isEmojiVariationDescription = function isEmojiVariationDescription(object) {
  return 'baseId' in object;
};
export var isMessagesKey = function isMessagesKey(key) {
  return key in messages;
};
export var toEmojiId = function toEmojiId(emoji) {
  return {
    shortName: emoji.shortName,
    id: emoji.id,
    fallback: emoji.fallback
  };
};
export var toOptionalEmojiId = function toOptionalEmojiId(emoji) {
  if (!emoji) {
    return undefined;
  }
  return toEmojiId(emoji);
};
export var isEmojiIdEqual = function isEmojiIdEqual(l, r) {
  return l === r || l && r && l.id === r.id && l.shortName === r.shortName;
};
export var containsEmojiId = function containsEmojiId(emojis, emojiId) {
  if (!emojiId) {
    return false;
  }
  for (var i = 0; i < emojis.length; i++) {
    if (isEmojiIdEqual(emojis[i], emojiId)) {
      return true;
    }
  }
  return false;
};
export var convertImageToMediaRepresentation = function convertImageToMediaRepresentation(rep) {
  return {
    mediaPath: rep.imagePath,
    height: rep.height,
    width: rep.width
  };
};
export var convertMediaToImageRepresentation = function convertMediaToImageRepresentation(rep, newImagePath) {
  return {
    imagePath: newImagePath || rep.mediaPath,
    height: rep.height,
    width: rep.width
  };
};
export var convertMediaToImageEmoji = function convertMediaToImageEmoji(emoji, newImagePath, useAlt) {
  var mediaRepresentation = emoji.representation;
  var mediaAltRepresentation = emoji.altRepresentation;
  var imgPath = !useAlt ? newImagePath : undefined;
  var altImgPath = useAlt ? newImagePath : undefined;
  if (!isMediaRepresentation(mediaRepresentation) && !isMediaRepresentation(mediaAltRepresentation)) {
    return emoji;
  }
  var representation = isMediaRepresentation(mediaRepresentation) ? convertMediaToImageRepresentation(mediaRepresentation, imgPath) : mediaRepresentation;
  var altRepresentation = isMediaRepresentation(mediaAltRepresentation) ? convertMediaToImageRepresentation(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
  var baseEmoji = _objectSpread(_objectSpread({}, emoji), {}, {
    representation: representation
  });
  return buildEmojiDescriptionWithAltRepresentation(baseEmoji, altRepresentation);
};

// Prevent altRepresentation: undefined from being returned in EmojiDescription
export var buildEmojiDescriptionWithAltRepresentation = function buildEmojiDescriptionWithAltRepresentation(emoji, altRepresentation) {
  if (!altRepresentation) {
    return emoji;
  }
  return _objectSpread(_objectSpread({}, emoji), {}, {
    altRepresentation: altRepresentation
  });
};
export var getCategoryId = function getCategoryId(emoji) {
  return emoji.category;
};